import { motion } from 'framer-motion';
import Tooltip from '@atoms/new/tooltip';
import { lightenColor } from './wordCloudStyles';

export default function WordChartWord({
  word, color, fontFamily, hasChip, stretchX = 1, stretchY = 1
}) {
  const { r, g, b } = lightenColor(color, 0.4);
  // stretchX/Y push positions out per-axis (the spread setting) without
  // scaling the glyph, so the font size stays put.
  const x = word.x * stretchX;
  const y = word.y * stretchY;
  return (
    <motion.div
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: 0,
        height: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      initial={{ x, y, rotate: word.rotate, opacity: 0, scale: 0.4 }}
      animate={{ x, y, rotate: word.rotate, opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.4 }}
      transition={{ type: 'spring', stiffness: 170, damping: 22 }}
    >
      <Tooltip content={`${word.votes} ${word.votes === 1 ? 'vote' : 'votes'}`} placement="top">
        <motion.span
          style={{
            display: 'block',
            whiteSpace: 'nowrap',
            lineHeight: 1,
            fontFamily,
            fontWeight: 900,
            color,
            userSelect: 'none',
            cursor: 'default',
            ...(hasChip ? {
              backgroundColor: `rgba(${r}, ${g}, ${b}, 0.55)`,
              padding: '0.16em 0.2em',
              borderRadius: '0.18em'
            } : {})
          }}
          animate={{ fontSize: word.size }}
          initial={{ fontSize: word.size }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        >
          {word.text}
        </motion.span>
      </Tooltip>
    </motion.div>
  );
}
